export default "__VITE_ASSET__BrJkUv9d__"